
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as ReferralAVkqksM_450vg74UT7wgj5Hxagi1oiBnjajcHyj32GkAAMeta } from "/app/pages/Referral.vue?macro=true";
import { default as WidgetWynDAcRyZMCr9ZMvAzQwQmfKZymp_45m8k_45tSG7sVFFQYMeta } from "/app/pages/[_lang]/Widget.vue?macro=true";
import { default as LeadI2hdQjexEEW804r3j2ORmIqDS64wN0ln4ObrB4T0MqwMeta } from "/app/pages/[_lang]/[_city]/Lead.vue?macro=true";
import { default as Options_454lg04Q4KCAty4js1WyI6pGFO4Vt3D1FGsq_U6Sv4vcMeta } from "/app/pages/[_lang]/[_city]/Options.vue?macro=true";
import { default as Category80ncEB0LLpTwTMVsojF_z3a_m4vGDUfG2vp97gULIZEMeta } from "/app/pages/[_lang]/[_city]/Category.vue?macro=true";
import { default as CoveragenfrRAuv2emleKysFTtuJ89sXS6e8XhTaJsJLctnt0JMMeta } from "/app/pages/[_lang]/[_city]/Coverage.vue?macro=true";
import { default as dateWTIvyk3znnKOL6UxYYsiuma5MXnNkxtZK9ECftxBXmsMeta } from "/app/pages/webview/[_lang]/[_city]/date.vue?macro=true";
import { default as Final88dCcBfMrk3QT_4512qFwUk1Bpw4bRDVdBXIMI6u2h5hUMeta } from "/app/pages/webview/[_lang]/[_city]/Final.vue?macro=true";
import { default as index3SgDkHhOd0eq18QqJ4gkGsiQ401saWD3J37CqPc9UecMeta } from "/app/pages/[_lang]/[_city]/personal/index.vue?macro=true";
import { default as OptionslubZpzDUrO_45Qwr_45jGQLEYc_45MrTON6SdWOdqV3Zn5hS0Meta } from "/app/pages/webview/[_lang]/[_city]/Options.vue?macro=true";
import { default as SummarysrlaR9EQ8MpbUuKGYgNbalnCb2EjB1SknJIBrLF_45_45YAMeta } from "/app/pages/webview/[_lang]/[_city]/Summary.vue?macro=true";
import { default as datet5w9l0UHzNK36lIEWHT3USn5906eQl7Rl9KzyZOtRwEMeta } from "/app/pages/webview/[_lang]/[_city]/v3/date.vue?macro=true";
import { default as paymentItZUEU3wc4j1XjZhhbfLwTu_45cPSP8_oRRnKvKSe55FAMeta } from "/app/pages/[_lang]/[_city]/personal/payment.vue?macro=true";
import { default as Categoryxh0ZlB4Lo8KCfAgdSznBWPqipoOe550Q_lyJs_45Qk9DoMeta } from "/app/pages/webview/[_lang]/[_city]/Category.vue?macro=true";
import { default as Coverage0u8RwHPfRHfQXBn_rqWRAMisf8xWgAdTfx5_459NIrG6wMeta } from "/app/pages/webview/[_lang]/[_city]/Coverage.vue?macro=true";
import { default as index2ve6YfVQ1OvcuhIn1hdbuQsYARSZEpHqDiHJwY4T8bgMeta } from "/app/pages/webview/[_lang]/[_city]/v3/index.vue?macro=true";
import { default as deep_45linkXaXTkWyClQwJD2tc9JSaDKaMqpI31VuAkbIdSI4wkmMMeta } from "/app/pages/webview/[_lang]/[_city]/deep-link.vue?macro=true";
import { default as categoryi_LS6D73Ai9Jf7Eef9Omedm2HLp4oC6hJOTJ77ftfSIMeta } from "/app/pages/webview/[_lang]/[_city]/v3/category.vue?macro=true";
import { default as newV1_45Vw8xhqtdr8l6pS2f49MnRiP8YqPtESs4aGkDskaoMeta } from "/app/pages/[_lang]/[_city]/personal/details/new.vue?macro=true";
import { default as auth_45callbackCGtToirJyPwaWpreN__vGvwoFmIr9jUznhMj8KV4GVYMeta } from "/app/pages/[_lang]/[_city]/personal/auth-callback.vue?macro=true";
import { default as index_45kGo1uYludAIZOZNRwRcqK9InD6pf4JOd2fMRORve8AMeta } from "/app/pages/[_lang]/[_city]/personal/details/index.vue?macro=true";
import { default as select7k7JIfhwNhutI578stcJp4JF_RcsNFITIhbCOjnhykEMeta } from "/app/pages/webview/[_lang]/[_city]/service/select.vue?macro=true";
import { default as existingPMuUs9U1pMn4ZKU1mW7u2fhjfLHPNQk362t9lIgeNK8Meta } from "/app/pages/[_lang]/[_city]/personal/details/existing.vue?macro=true";
import { default as Date8c5JH9nhwHYToxEDozhtR7v2gzzohIf06dPEOuxaVosMeta } from "/app/pages/webview/[_lang]/[_city]/subscription/Date.vue?macro=true";
import { default as onboarding_PKGOFRkvCziv5ey_45nLcAceI29kGuPZDSkwa9MaIyZwMeta } from "/app/pages/webview/[_lang]/[_city]/service/onboarding.vue?macro=true";
import { default as Finalh2XQuJx3GfwZOmo_45bXw_sDZEikik_OpmfmsvzThM81kMeta } from "/app/pages/webview/[_lang]/[_city]/subscription/Final.vue?macro=true";
import { default as extrasD6ltp7V_ID6A3BxRze_LPNFUtekbD2gV0HPGhaYZNSwMeta } from "/app/pages/webview/[_lang]/[_city]/subscription/extras.vue?macro=true";
import { default as MileagevV6slXa_45EptByr66doL6vCLK7gDXGxfN9DYCPrmW1WMMeta } from "/app/pages/webview/[_lang]/[_city]/subscription/Mileage.vue?macro=true";
import { default as Paymentby23tdh75lcbspUsmJAXICuMSeuGph_eEPYygo1yNGcMeta } from "/app/pages/webview/[_lang]/[_city]/subscription/Payment.vue?macro=true";
import { default as select_45funnel6RFEM9bMYFCEisHk_45uiHp4uEs9fRKzXvktRiP18b5McMeta } from "/app/pages/webview/[_lang]/[_city]/service/select-funnel.vue?macro=true";
import { default as CategorygD7s1QrRCpU1P2s04DFrSOTK7k1_SNWwgo_45IOYANcVIMeta } from "/app/pages/webview/[_lang]/[_city]/subscription/Category.vue?macro=true";
import { default as Coverageq32vPKe7rLsxZlApyHeiRd5RmUev5iqqMMGuxXlO2hQMeta } from "/app/pages/webview/[_lang]/[_city]/subscription/Coverage.vue?macro=true";
import { default as onboarding7jZXQO5Q_459jtdHIH7ncMCdgz_hHRXAq92AGKtj9TzD8Meta } from "/app/pages/webview/[_lang]/[_city]/v3/service/onboarding.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "Referral",
    path: "/Referral",
    component: () => import("/app/pages/Referral.vue")
  },
  {
    name: "_lang-Widget",
    path: "/:_lang()/Widget",
    meta: WidgetWynDAcRyZMCr9ZMvAzQwQmfKZymp_45m8k_45tSG7sVFFQYMeta || {},
    component: () => import("/app/pages/[_lang]/Widget.vue")
  },
  {
    name: "_lang-_city-Lead",
    path: "/:_lang()/:_city()/Lead",
    component: () => import("/app/pages/[_lang]/[_city]/Lead.vue")
  },
  {
    name: "_lang-_city-Options",
    path: "/:_lang()/:_city()/Options",
    component: () => import("/app/pages/[_lang]/[_city]/Options.vue")
  },
  {
    name: "_lang-_city-Category",
    path: "/:_lang()/:_city()/Category",
    component: () => import("/app/pages/[_lang]/[_city]/Category.vue")
  },
  {
    name: "_lang-_city-Coverage",
    path: "/:_lang()/:_city()/Coverage",
    component: () => import("/app/pages/[_lang]/[_city]/Coverage.vue")
  },
  {
    name: "webview-_lang-_city-date",
    path: "/webview/:_lang()/:_city()/date",
    meta: dateWTIvyk3znnKOL6UxYYsiuma5MXnNkxtZK9ECftxBXmsMeta || {},
    component: () => import("/app/pages/webview/[_lang]/[_city]/date.vue")
  },
  {
    name: "webview-_lang-_city-Final",
    path: "/webview/:_lang()/:_city()/Final",
    meta: Final88dCcBfMrk3QT_4512qFwUk1Bpw4bRDVdBXIMI6u2h5hUMeta || {},
    component: () => import("/app/pages/webview/[_lang]/[_city]/Final.vue")
  },
  {
    name: "_lang-_city-personal",
    path: "/:_lang()/:_city()/personal",
    component: () => import("/app/pages/[_lang]/[_city]/personal/index.vue")
  },
  {
    name: "webview-_lang-_city-Options",
    path: "/webview/:_lang()/:_city()/Options",
    meta: OptionslubZpzDUrO_45Qwr_45jGQLEYc_45MrTON6SdWOdqV3Zn5hS0Meta || {},
    component: () => import("/app/pages/webview/[_lang]/[_city]/Options.vue")
  },
  {
    name: "webview-_lang-_city-Summary",
    path: "/webview/:_lang()/:_city()/Summary",
    meta: SummarysrlaR9EQ8MpbUuKGYgNbalnCb2EjB1SknJIBrLF_45_45YAMeta || {},
    component: () => import("/app/pages/webview/[_lang]/[_city]/Summary.vue")
  },
  {
    name: "webview-_lang-_city-v3-date",
    path: "/webview/:_lang()/:_city()/v3/date",
    meta: datet5w9l0UHzNK36lIEWHT3USn5906eQl7Rl9KzyZOtRwEMeta || {},
    component: () => import("/app/pages/webview/[_lang]/[_city]/v3/date.vue")
  },
  {
    name: "_lang-_city-personal-payment",
    path: "/:_lang()/:_city()/personal/payment",
    component: () => import("/app/pages/[_lang]/[_city]/personal/payment.vue")
  },
  {
    name: "webview-_lang-_city-Category",
    path: "/webview/:_lang()/:_city()/Category",
    meta: Categoryxh0ZlB4Lo8KCfAgdSznBWPqipoOe550Q_lyJs_45Qk9DoMeta || {},
    component: () => import("/app/pages/webview/[_lang]/[_city]/Category.vue")
  },
  {
    name: "webview-_lang-_city-Coverage",
    path: "/webview/:_lang()/:_city()/Coverage",
    meta: Coverage0u8RwHPfRHfQXBn_rqWRAMisf8xWgAdTfx5_459NIrG6wMeta || {},
    component: () => import("/app/pages/webview/[_lang]/[_city]/Coverage.vue")
  },
  {
    name: "webview-_lang-_city-v3",
    path: "/webview/:_lang()/:_city()/v3",
    meta: index2ve6YfVQ1OvcuhIn1hdbuQsYARSZEpHqDiHJwY4T8bgMeta || {},
    component: () => import("/app/pages/webview/[_lang]/[_city]/v3/index.vue")
  },
  {
    name: "webview-_lang-_city-deep-link",
    path: "/webview/:_lang()/:_city()/deep-link",
    meta: deep_45linkXaXTkWyClQwJD2tc9JSaDKaMqpI31VuAkbIdSI4wkmMMeta || {},
    component: () => import("/app/pages/webview/[_lang]/[_city]/deep-link.vue")
  },
  {
    name: "webview-_lang-_city-v3-category",
    path: "/webview/:_lang()/:_city()/v3/category",
    meta: categoryi_LS6D73Ai9Jf7Eef9Omedm2HLp4oC6hJOTJ77ftfSIMeta || {},
    component: () => import("/app/pages/webview/[_lang]/[_city]/v3/category.vue")
  },
  {
    name: "_lang-_city-personal-details-new",
    path: "/:_lang()/:_city()/personal/details/new",
    component: () => import("/app/pages/[_lang]/[_city]/personal/details/new.vue")
  },
  {
    name: "_lang-_city-personal-auth-callback",
    path: "/:_lang()/:_city()/personal/auth-callback",
    component: () => import("/app/pages/[_lang]/[_city]/personal/auth-callback.vue")
  },
  {
    name: "_lang-_city-personal-details",
    path: "/:_lang()/:_city()/personal/details",
    component: () => import("/app/pages/[_lang]/[_city]/personal/details/index.vue")
  },
  {
    name: "webview-_lang-_city-service-select",
    path: "/webview/:_lang()/:_city()/service/select",
    meta: select7k7JIfhwNhutI578stcJp4JF_RcsNFITIhbCOjnhykEMeta || {},
    component: () => import("/app/pages/webview/[_lang]/[_city]/service/select.vue")
  },
  {
    name: "_lang-_city-personal-details-existing",
    path: "/:_lang()/:_city()/personal/details/existing",
    component: () => import("/app/pages/[_lang]/[_city]/personal/details/existing.vue")
  },
  {
    name: "webview-_lang-_city-subscription-Date",
    path: "/webview/:_lang()/:_city()/subscription/Date",
    meta: Date8c5JH9nhwHYToxEDozhtR7v2gzzohIf06dPEOuxaVosMeta || {},
    component: () => import("/app/pages/webview/[_lang]/[_city]/subscription/Date.vue")
  },
  {
    name: "webview-_lang-_city-service-onboarding",
    path: "/webview/:_lang()/:_city()/service/onboarding",
    meta: onboarding_PKGOFRkvCziv5ey_45nLcAceI29kGuPZDSkwa9MaIyZwMeta || {},
    component: () => import("/app/pages/webview/[_lang]/[_city]/service/onboarding.vue")
  },
  {
    name: "webview-_lang-_city-subscription-Final",
    path: "/webview/:_lang()/:_city()/subscription/Final",
    meta: Finalh2XQuJx3GfwZOmo_45bXw_sDZEikik_OpmfmsvzThM81kMeta || {},
    component: () => import("/app/pages/webview/[_lang]/[_city]/subscription/Final.vue")
  },
  {
    name: "webview-_lang-_city-subscription-extras",
    path: "/webview/:_lang()/:_city()/subscription/extras",
    meta: extrasD6ltp7V_ID6A3BxRze_LPNFUtekbD2gV0HPGhaYZNSwMeta || {},
    component: () => import("/app/pages/webview/[_lang]/[_city]/subscription/extras.vue")
  },
  {
    name: "webview-_lang-_city-subscription-Mileage",
    path: "/webview/:_lang()/:_city()/subscription/Mileage",
    meta: MileagevV6slXa_45EptByr66doL6vCLK7gDXGxfN9DYCPrmW1WMMeta || {},
    component: () => import("/app/pages/webview/[_lang]/[_city]/subscription/Mileage.vue")
  },
  {
    name: "webview-_lang-_city-subscription-Payment",
    path: "/webview/:_lang()/:_city()/subscription/Payment",
    meta: Paymentby23tdh75lcbspUsmJAXICuMSeuGph_eEPYygo1yNGcMeta || {},
    component: () => import("/app/pages/webview/[_lang]/[_city]/subscription/Payment.vue")
  },
  {
    name: "webview-_lang-_city-service-select-funnel",
    path: "/webview/:_lang()/:_city()/service/select-funnel",
    meta: select_45funnel6RFEM9bMYFCEisHk_45uiHp4uEs9fRKzXvktRiP18b5McMeta || {},
    component: () => import("/app/pages/webview/[_lang]/[_city]/service/select-funnel.vue")
  },
  {
    name: "webview-_lang-_city-subscription-Category",
    path: "/webview/:_lang()/:_city()/subscription/Category",
    meta: CategorygD7s1QrRCpU1P2s04DFrSOTK7k1_SNWwgo_45IOYANcVIMeta || {},
    component: () => import("/app/pages/webview/[_lang]/[_city]/subscription/Category.vue")
  },
  {
    name: "webview-_lang-_city-subscription-Coverage",
    path: "/webview/:_lang()/:_city()/subscription/Coverage",
    meta: Coverageq32vPKe7rLsxZlApyHeiRd5RmUev5iqqMMGuxXlO2hQMeta || {},
    component: () => import("/app/pages/webview/[_lang]/[_city]/subscription/Coverage.vue")
  },
  {
    name: "webview-_lang-_city-v3-service-onboarding",
    path: "/webview/:_lang()/:_city()/v3/service/onboarding",
    meta: onboarding7jZXQO5Q_459jtdHIH7ncMCdgz_hHRXAq92AGKtj9TzD8Meta || {},
    component: () => import("/app/pages/webview/[_lang]/[_city]/v3/service/onboarding.vue")
  }
]